import React, { Component } from 'react';
import { Button, Card, CircularProgress, Grid } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import "./home.css";
import { Product } from "../../../classes/types/product/product";
import { ProductHandler } from "../../../classes/methods/productMethods/productMethods";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import CarouselCard from "../../customComponents/carouselCard/carouselCard";
import { HomeImages } from "../../../classes/types/homeImages/homeImages";
import { HomeImagesHandler } from "../../../classes/methods/HomeImageMethods/homeImageMethods";

interface props {
    navigate: ReturnType<typeof useNavigate>;
}

interface state {
    lowStockProducts: Array<Product>,
    mostViewedProducts: Array<Product>,
    onSaleProducts: Array<Product>,
    lowStockProductsLoading: boolean,
    mostViewedProductsLoading: boolean,
    onSaleProductsLoading: boolean,
    carouselHover: boolean,
    carouselHover2: boolean,
    carouselHover3: boolean,
    homeImages: Array<HomeImages>,
}

const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 6 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 6 },
    tablet: { breakpoint: { max: 1024, min: 600 }, items: 3 },
    mobile: { breakpoint: { max: 600, min: 400 }, items: 1 },
    smallMobile: { breakpoint: { max: 400, min: 0 }, items: 1 },
};

class Home extends Component<props, state> {
    _ismounted: boolean = false;

    constructor(props: props) {
        super(props);
        this.state = {
            lowStockProducts: [],
            mostViewedProducts: [],
            onSaleProducts: [],
            lowStockProductsLoading: true,
            mostViewedProductsLoading: true,
            onSaleProductsLoading: true,
            carouselHover: false,
            carouselHover2: false,
            carouselHover3: false,
            homeImages: [],
        };
    }

    componentWillUnmount() {
        this._ismounted = false;
    }

    componentDidMount() {
        this._ismounted = true;
        this.refreshData();
    }

    refreshData = () => {
        if (!this._ismounted) return;

        this.setState({
            onSaleProductsLoading: true,
            lowStockProductsLoading: true,
            mostViewedProductsLoading: true,
        });

        HomeImagesHandler.getHomeImages()
            .then(newHomeImages => this.setState({ homeImages: newHomeImages, mostViewedProductsLoading: false }))
            .catch(() => {});

        ProductHandler.GetLowStockProducts()
            .then(newLowStockProducts => {
                // Shuffle low stock
                for (let i = newLowStockProducts.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [newLowStockProducts[i], newLowStockProducts[j]] = [newLowStockProducts[j], newLowStockProducts[i]];
                }
                this.setState({
                    lowStockProducts: newLowStockProducts.slice(0, 10),
                    lowStockProductsLoading: false,
                });
            })
            .catch(() => {});
    }

    onMouseEnterCarousel = () => this.setState({ carouselHover: true });
    onMouseLeaveCarousel = () => this.setState({ carouselHover: false });
    onMouseEnterCarousel3 = () => this.setState({ carouselHover3: true });
    onMouseLeaveCarousel3 = () => this.setState({ carouselHover3: false });

    render() {
        return (
            <div className="home">
                <div style={{ display: "flex", padding: "2% 4% 1% 2%", minHeight: '310px', backgroundColor: "#e9e9e9" }}>
                    <div style={{ width: "12%", textAlign: "left", paddingTop: '0.5%' }}>
                        <span style={{ fontSize: "25px", fontWeight: "bold" }}>PRODOTTI IN PROMO</span>
                    </div>
                    <div onMouseEnter={this.onMouseEnterCarousel} onMouseLeave={this.onMouseLeaveCarousel} style={{ width: "88%" }}>
                        <Carousel
                            responsive={responsive}
                            additionalTransfrom={0}
                            arrows={this.state.carouselHover}
                            autoPlay
                            autoPlaySpeed={2000}
                            centerMode={false}
                            containerClass="carouselStyle"
                            draggable
                            focusOnSelect={false}
                            infinite
                            keyBoardControl
                            minimumTouchDrag={80}
                            renderButtonGroupOutside
                            showDots
                            slidesToSlide={1}
                            swipeable
                        >
                            {this.state.lowStockProductsLoading
                                ? <CircularProgress size={30} style={{ color: "#b3071b", marginTop: '2%' }} />
                                : this.state.lowStockProducts.map((product, index) => <CarouselCard key={product.id + index} product={product} />)
                            }
                        </Carousel>
                    </div>
                </div>
                <Grid container>
                    {this.state.homeImages.length > 0 && !this.state.mostViewedProductsLoading &&
                        <Grid style={{ borderRight: '1px solid lightgray' }} container item xs={12}>
                            {this.state.homeImages.map(homeImage => (
                                <Grid xs={12} sm={6} md={6} lg={6} xl={6} style={{ height: "fit-content" }} item key={homeImage.id}>
                                    <Card style={{
                                        color: "white",
                                        textAlign: "left",
                                        borderRadius: "unset",
                                        margin: 0,
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: "center center",
                                        backgroundImage: `url(${homeImage.image.link})`,
                                        height: "60vh"
                                    }}>
                                        <Grid container direction="column" style={{ backgroundColor: "rgba(0,0,0, 0.6)", padding: '5vh 2vw', width: "100%", height: "100%" }}>
                                            <span style={{ marginBottom: "2%", fontSize: "32px" }}><b>{homeImage.title}</b></span><br />
                                            <span style={{ marginBottom: "2%", fontSize: "25px" }}><b>{homeImage.subTitle}</b></span><br /><br />
                                            <span style={{ marginBottom: "2%" }}>{homeImage.description}</span><br /><br />
                                            <Link to={homeImage.url}>
                                                <Button style={{ marginTop: "auto", width: "fit-content" }} variant="contained" color="primary">Acquista Ora</Button>
                                            </Link>
                                        </Grid>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    }
                </Grid>
            </div>
        );
    }
}

// --- Wrapper per React Router v6
export default function HomeWrapper(props: any) {
    const navigate = useNavigate();
    return <Home {...props} navigate={navigate} />;
}
